import { render } from "./BuildingSelectionModal.vue?vue&type=template&id=ef2afdfc&scoped=true"
import script from "./BuildingSelectionModal.vue?vue&type=script&lang=js"
export * from "./BuildingSelectionModal.vue?vue&type=script&lang=js"

import "./BuildingSelectionModal.vue?vue&type=style&index=0&id=ef2afdfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef2afdfc"]])

export default __exports__